/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { AccessGrantRequestToJSON, AccessGrantResponseFromJSON, PagedResponseOfAccessGrantListEntryFromJSON, } from '../models';
/**
 *
 */
var AccessGrantRestControllerApi = /** @class */ (function (_super) {
    __extends(AccessGrantRestControllerApi, _super);
    function AccessGrantRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new access grant  \'Permission#CREATE_ACCESS_GRANT\' is required to access to this endpoint
     * Create a new access grant  \'Permission#CREATE_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.createAccessGrantRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.accessGrantRequest === null || requestParameters.accessGrantRequest === undefined) {
                            throw new runtime.RequiredError('accessGrantRequest', 'Required parameter requestParameters.accessGrantRequest was null or undefined when calling createAccessGrant.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/accessgrants",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: AccessGrantRequestToJSON(requestParameters.accessGrantRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return AccessGrantResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new access grant  \'Permission#CREATE_ACCESS_GRANT\' is required to access to this endpoint
     * Create a new access grant  \'Permission#CREATE_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.createAccessGrant = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAccessGrantRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete access grant  \'Permission#DELETE_ACCESS_GRANT\' is required to access to this endpoint
     * Delete access grant  \'Permission#DELETE_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.deleteAccessGrantRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.accessGrantId === null || requestParameters.accessGrantId === undefined) {
                            throw new runtime.RequiredError('accessGrantId', 'Required parameter requestParameters.accessGrantId was null or undefined when calling deleteAccessGrant.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/accessgrants/{accessGrantId}".replace("{".concat("accessGrantId", "}"), encodeURIComponent(String(requestParameters.accessGrantId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete access grant  \'Permission#DELETE_ACCESS_GRANT\' is required to access to this endpoint
     * Delete access grant  \'Permission#DELETE_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.deleteAccessGrant = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteAccessGrantRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get access grant details  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     * Get access grant details  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.getAccessGrantRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.accessGrantId === null || requestParameters.accessGrantId === undefined) {
                            throw new runtime.RequiredError('accessGrantId', 'Required parameter requestParameters.accessGrantId was null or undefined when calling getAccessGrant.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/accessgrants/{accessGrantId}".replace("{".concat("accessGrantId", "}"), encodeURIComponent(String(requestParameters.accessGrantId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return AccessGrantResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get access grant details  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     * Get access grant details  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.getAccessGrant = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccessGrantRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get access grants of an organisation  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     * Get access grants of an organisation  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.getAccessGrantsOfOrganisationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.organisationId === null || requestParameters.organisationId === undefined) {
                            throw new runtime.RequiredError('organisationId', 'Required parameter requestParameters.organisationId was null or undefined when calling getAccessGrantsOfOrganisation.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/accessgrants/organisation/{organisationId}".replace("{".concat("organisationId", "}"), encodeURIComponent(String(requestParameters.organisationId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return AccessGrantResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get access grants of an organisation  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     * Get access grants of an organisation  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.getAccessGrantsOfOrganisation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccessGrantsOfOrganisationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get effective access grants of a user  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     * Get effective access grants of a user  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.getAccessGrantsOfUserRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling getAccessGrantsOfUser.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/accessgrants/user/{userId}".replace("{".concat("userId", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(AccessGrantResponseFromJSON); })];
                }
            });
        });
    };
    /**
     * Get effective access grants of a user  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     * Get effective access grants of a user  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.getAccessGrantsOfUser = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccessGrantsOfUserRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List access grant using pagination  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     * List access grant using pagination  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.listAccessGrantsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/accessgrants",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfAccessGrantListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List access grant using pagination  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     * List access grant using pagination  \'Permission#READ_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.listAccessGrants = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listAccessGrantsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update access grant  \'Permission#UPDATE_ACCESS_GRANT\' is required to access to this endpoint
     * Update access grant  \'Permission#UPDATE_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.updateAccessGrantRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.accessGrantId === null || requestParameters.accessGrantId === undefined) {
                            throw new runtime.RequiredError('accessGrantId', 'Required parameter requestParameters.accessGrantId was null or undefined when calling updateAccessGrant.');
                        }
                        if (requestParameters.accessGrantRequest === null || requestParameters.accessGrantRequest === undefined) {
                            throw new runtime.RequiredError('accessGrantRequest', 'Required parameter requestParameters.accessGrantRequest was null or undefined when calling updateAccessGrant.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/accessgrants/{accessGrantId}".replace("{".concat("accessGrantId", "}"), encodeURIComponent(String(requestParameters.accessGrantId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: AccessGrantRequestToJSON(requestParameters.accessGrantRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return AccessGrantResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update access grant  \'Permission#UPDATE_ACCESS_GRANT\' is required to access to this endpoint
     * Update access grant  \'Permission#UPDATE_ACCESS_GRANT\' is required to access to this endpoint
     */
    AccessGrantRestControllerApi.prototype.updateAccessGrant = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateAccessGrantRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AccessGrantRestControllerApi;
}(runtime.BaseAPI));
export { AccessGrantRestControllerApi };
